import React from "react";
import { t } from "i18next";
import Layout from "./Layout";
import { Link, useParams } from "react-router-dom";
import Deposit from "./Deposit";
import Withdraw from "./Withdraw";

const Bank = () => {
  const { type } = useParams();
  return (
    <Layout>
      <div className="row no-gutters">
        <div className="col col-12">
          <div className="px-0" style={{ height: "100%" }}>
            <div
              style={{ height: "50px" }}
              className="row hidden-md-and-up mobile-header no-gutters"
            >
              <div
                className={`mobile-header-item col col-6 ${
                  type == "deposit" ? "selected" : ""
                } `}
              >
                <Link
                  to="/bank/deposit"
                  className={
                    type == "deposit"
                      ? `router-link-exact-active router-link-active`
                      : ""
                  }
                  style={{
                    "-webkit-text-decoration": "unset !important",
                    "text-decoration": "unset !important",
                  }}
                >
                  <span>{t("Deposit")}</span>
                </Link>
              </div>
              <div
                className={`text-center mobile-header-item col col-6 ${
                  type == "withdrawal" ? "selected" : ""
                }`}
              >
                <Link
                  to="/bank/withdrawal"
                  className={
                    type == "withdrawal"
                      ? `router-link-exact-active router-link-active`
                      : ""
                  }
                  style={{
                    "-webkit-text-decoration": "unset !important",
                    "text-decoration": "unset !important",
                  }}
                >
                  <span>{t("Withdrawal")}</span>
                </Link>
              </div>
            </div>
            <div className="desktop_depo_card v-card v-sheet theme--light">
              {/**/}
              <div className="v-card__title hidden-sm-and-down pl-3 ml-7">
                <label className="--v-primary-base depo-desktop-txt text-left text-capitalize">
                  {t("Deposit")}
                </label>
              </div>
              {type == "deposit" && <Deposit />}
              {type == "withdrawal" && <Withdraw />}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Bank;
